import React from 'react'
import 'rc-calendar/assets/index.css'
import parse from 'html-react-parser'
import desk from '../../images/png/desk.png'
import Grid from '@mui/material/Grid'
import EditIcon from '@mui/icons-material/Edit'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import { FormatHomePageMessage, DoesThisUserHavePermissionToEditTheFrontPageText } from '../utilities/helperFunctions'

class Gallo extends React.Component {
    state = {
        message: false,
        messageField: this.props.message,
        notes: false,
        notesField: this.props.notes,
        hasPermissionToEditText: false,
        logoUrl: '',
        IElogoUrl: ''

    }

    componentDidMount() {
        this.setState({ IElogoUrl: `${process.env.REACT_APP_STATIC_WEB}/images/IElogo1.png` })
        this.setState({ logoUrl: `${process.env.REACT_APP_STATIC_WEB}/images/${this.props.customerID}/logo1.png` })

        if (this.props.currentUser !== null) {
            if (this.props.currentUser["id"] !== this.props.id) {
                // If we switched users, disable the edit entirely, we'll process this once all of the current user information is updated
                this.setState({ hasPermissionToEditText: false })
            } else {
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentUser !== null) {
            if (prevProps.currentUser === null) {
                // Update if we don't have a current user from previous props
                this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
            } else {
                // Check and update if we have confirmed the user has switched
                if (prevProps.currentUser["id"] !== this.props.currentUser["id"]) {
                    this.setState({ hasPermissionToEditText: DoesThisUserHavePermissionToEditTheFrontPageText(this.props.currentUser) })
                }
            }
        }
    }

    goToPresentations = (event) => {
        event.preventDefault()
        this.props.history.push("/presentations")
    }

    handleMessageSubmit = (event) => {
        event.preventDefault()
    }

    messageSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerMessage(this.props.customerID, this.state.messageField)
        this.setState({ message: false })
    }

    handleNotesSubmit = (event) => {
        event.preventDefault()
    }

    notesSubmit = (event) => {
        event.preventDefault()
        this.props.updateCustomerNotes(this.props.customerID, this.state.notesField)
        this.setState({ notes: false })
    }

    changeMessage = (event) => {
        event.preventDefault()
        this.setState({ messageField: event.target.value })
    }

    changeNotes = (event) => {
        event.preventDefault()
        this.setState({ notesField: event.target.value })
    }

    messageCancel = (event) => {
        event.preventDefault()
        this.setState({ message: false })
    }

    notesCancel = (event) => {
        event.preventDefault()
        this.setState({ notes: false })
    }

    toggleMessage = (event) => {
        this.setState({ message: !this.state.message })
    }

    toggleNotes = (event) => {
        this.setState({ notes: !this.state.notes })
    }

    Capitalize(str) {
        if (str)
            return str.charAt(0).toUpperCase() + str.slice(1);
        else
            return ""
    }

    renderEditButton = (toggle) => {
        if (this.state.hasPermissionToEditText) {
            return <button onClick={toggle}>
                {' '}
                <EditIcon />
                {' '}
            </button>
        }
    }

    render() {
        return (<div className="mainWrapper">
            <div className="bodyPart">
                <div className="contentWrapper">
                    <div className="dashTop">
                        <div className="welcomeuserLeft">
                            <h3>
                                <span style={{ color: "#3b86f6" }}>Welcome {this.Capitalize(this.props.firstName)}</span>
                            </h3>
                            <p>Thanks for joining us, let's get started</p>
                        </div>
                        <div className="welcomeuserRight">
                            <img src={this.state.logoUrl} alt="BI Cloud" onError={(e) => { e.target.onerror = null; e.target.src = this.state.IElogoUrl }} />
                            <img src={desk} alt="BI Cloud" />
                        </div>
                    </div>
                    <div className="dashBottom">
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <div className="innerBoxes">
                                    <h3>
                                        <span style={{ color: "#3b86f6" }}>A Message from DRIVE</span>
                                        {this.renderEditButton(this.toggleMessage)}
                                    </h3>
                                    {!this.state.message ? (
                                        <div className="textBox">
                                            <p>
                                                {parse(FormatHomePageMessage(this.props.message) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="textBox">
                                            <textarea
                                                className="editableTextBox"
                                                value={
                                                    this.state.messageField
                                                    || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                                                }
                                                onKeyUp={this.handleMessageSubmit}
                                                onChange={this.changeMessage}
                                            />
                                            <div className="centerButtons">
                                                <button>
                                                    {' '}
                                                    <CloseIcon onClick={this.toggleMessage} />
                                                    {' '}
                                                </button>
                                                <button>
                                                    {' '}
                                                    <DoneIcon onClick={this.messageSubmit} />
                                                    {' '}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="innerBoxes">
                                    <h3>
                                        <span style={{ color: "#3b86f6" }}>Latest Files and Data Updates</span>
                                        {this.renderEditButton(this.toggleNotes)}
                                    </h3>
                                    {!this.state.notes ? (
                                        <div className="textBox">
                                            <p>
                                                {parse(FormatHomePageMessage(this.props.notes) || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team')}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="textBox">
                                            <textarea
                                                className="editableTextBox"
                                                value={
                                                    this.state.notesField
                                                    || 'This is the XP3 BI Cloud portal, click me to leave Updates for your team'
                                                }
                                                onChange={this.changeNotes}
                                                onKeyUp={this.handleNotesSubmit}
                                            />
                                            <div className="centerButtons">
                                                <button>
                                                    {' '}
                                                    <CloseIcon onClick={this.toggleNotes} />
                                                    {' '}
                                                </button>
                                                <button>
                                                    {' '}
                                                    <DoneIcon onClick={this.notesSubmit} />
                                                    {' '}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div style={{ float: "right", width: "100%", textAlign: "right" }}>
                        <div className="currentVersionNumber">Version {global.appVersion}</div>
                    </div>
                </div>
            </div>
        </div>)
    }
}

export default Gallo